import { Box, Divider, Grid, Stack, Typography } from "@mui/material";
import i18n from "../../i18n-config";
import theme from "../../theme/theme";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

type MenuItem = {
  key: string;
  title: string;
};

const MENU_ITEMS: MenuItem[] = [
  {
    key: "profile",
    title: "profile",
  },
  {
    key: "gestion-mot-pass",
    title: "gestion_mot_pass",
  },
  {
    key: "gestion-users",
    title: "gestion_users",
  },
  {
    key: "categories",
    title: "categories",
  },
];

function Parametre() {
  const navigate = useNavigate();
  const location = useLocation();

  const onItemPress = (item: string) => {
    navigate(item);
  };

  const renderItem = (item: MenuItem) => {
    return (
      <>
        <Typography
          key={item.key}
          onClick={() => onItemPress(item.key)}
          color={
            location.pathname.includes(item.key)
              ? theme.colors.primary
              : theme.colors.black
          }
          sx={{cursor: 'pointer'}}
          fontWeight={location.pathname.includes(item.key)
            ? 600
            : 400}
        >
          {i18n.t(item.title)}
        </Typography>
        {item.key !== "categories" ? <Divider sx={{ my: 1.5 }} /> : null}
      </>
    );
  };
  return (
    <Box sx={{ height: "100vh", backgroundColor: "#F9F9F9" }} p={3} pt={6}>
      <Stack direction={"row"} justifyContent="space-between" mb={3}>
        <Typography fontSize={22} fontWeight="600">
          {i18n.t("parametres")}
        </Typography>
      </Stack>
      <Grid container spacing={5}>
        <Grid item xs={3}>
          <Box sx={{ backgroundColor: "white", borderRadius: 2, p: 2, py: 3 }}>
            {MENU_ITEMS.map(renderItem)}
          </Box>
        </Grid>
        <Grid item xs={9}>
          <Outlet />
        </Grid>
      </Grid>
      
    </Box>
  );
}

export default Parametre;
